export default {
      id: "check-usage",
      viewBox: "0 0 13 10",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }